import ManufImg from "../../Images/reactor.jpg";
export function Manufacture() {
  return (
    <section className="about-wrap-layout1">
      <div className="container">
        <div className="row">
          <div className="about-box-layout1 order-xl-8 col-xl-8 col-12">
            <div className="item-content">
              <h2 className="item-title"> Manufacturing </h2>
              <p>
                Equipped with state-of-the-art facilities and the latest
                technology, Krufren is a leading manufacturer of niche drugs,
                mainly APIs and their formulations. Our carefully selected
                product portfolio features an impressive line of therapies that
                are sought after by customers worldwide. We specialize in
                developing and manufacturing niche drug generic APIs. Currently,
                we have approximately 22+ APIs on our list. We are also actively
                working on developing specialty chemicals and intermediates for
                our APIs for commercial use. We have successfully commenced the
                sale of our first intermediate, 2-amino acetophenone, which is
                an intermediate for linagliptin, along with its industrial
                applications. Our products span across a variety of categories,
                including cardiology, nephrology, anesthetics, anti-tissue,
                anti-bacterial, and we are also in the process of developing
                orphan drugs. Additionally, we have a robust pipeline of 10 APIs
                and 2 intermediates at various stages of development.
              </p>
              <p>
                We have one low-volume high-cost and one high-volume low-cost,
                cleanroom facility for API manufacturing. We are also currently
                working on expanding our facility for in-house manufacturing of
                intermediates, which will help reduce costs and supply
                intermediates at competitive rates. Additionally, under
                development, is our new facility for the production of
                large-volume APIs. This expansion will help us cater to the
                ever-growing demand for our products while achieving economies
                of scale and improving delivery timelines. This will be mutually
                beneficial for both us and our customers.
              </p>
              <p>
                {" "}
                krufren pharma operates a dedicated high-pressure hydrogenation
                facility designed for reduction processes, ensuring the safe and
                efficient production of specialized chemical compounds.
              </p>
              <p>
                {" "}
                We have a highly skilled team of regulatory affairs specialists
                who are well versed with regulatory policies and procedures
                around the world.
              </p>
            </div>
          </div>

          <div
            className="about-box-layout2 order-xl-1 col-xl-4 col-lg-4 col-12"
            style={{ marginBottom: "20px" }}
          >
            <div className="item-im">
              <img src={ManufImg} alt="about" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
